import { useUserId } from "../../../../query/hooks/helpers";
import { usePayrollSettings } from "../../../../query/payments/queries";
import { DataView } from "../../../../shared/components/DataView";
import { TaxFormType } from "@wingspanhq/payments/dist/interfaces/taxForm";
import { useCurrentTaxFilingYear } from "../../utils/useCurrentTaxFilingYear";
import { IFilingSettings1099 } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { MISCDescription } from "../../components/MISCDescription";
import { selectorTypeFormLabel } from "../../selectors/selectorTypeFormLabel";

export const FormType: React.FC<{}> = () => {
  const userId = useUserId();
  const currentYear = useCurrentTaxFilingYear();
  const queryPayrollSettings = usePayrollSettings(userId);

  const filingSettings =
    queryPayrollSettings.data?.calculationSettings1099?.filingSettings?.[
      `${currentYear}` as keyof IFilingSettings1099
    ];
  const taxFormType = filingSettings?.taxFormType;

  return (
    <DataView
      loading={queryPayrollSettings.isLoading}
      title="Form type"
      header={{
        label: {
          text: "Form type",
          helperText:
            "Once set, the form type will be locked in for the tax year."
        }
      }}
      data={[
        {
          label: "1099 type",
          value: selectorTypeFormLabel(taxFormType)
        }
      ]}
    >
      {taxFormType === TaxFormType.Form1099Misc ? <MISCDescription /> : null}
    </DataView>
  );
};
